import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCU9Pt902mrXjDFuo8h9Anr-WQqNnDnkE4",
  authDomain: "addictshoelk-3d7b8.firebaseapp.com",
  databaseURL: "https://addictshoelk-3d7b8-default-rtdb.firebaseio.com",
  projectId: "addictshoelk-3d7b8",
  storageBucket: "addictshoelk-3d7b8.firebasestorage.app",
  messagingSenderId: "910212690306",
  appId: "1:910212690306:web:7b169751a4e8eb94501f9b",
  measurementId: "G-0T8C4J9FV2"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;